<template>
  <div v-show="show" class="mask">
    <div class="dialog">
      <div class="title">
        <span>订单详情</span>
        <a style="cursor: pointer;padding: 20px 20px 20px 20px" @click="closeShow">X</a>
      </div>
      <div class="content">
        <div class="item">
          <div class="item-label">
            基础服务
          </div>
          <div style="width: 70%;" class="item-content">
            <span>{{`单张电子照${isPrint?`+排版照`:''}`}}</span>
            <span>￥{{(appInfo.ele_price/100).toFixed(2)}}</span>
          </div>
        </div>
        <div class="item">
          <div class="item-label">
            增值服务
          </div>
          <div v-show="backgroundColor.length>1" @click="multipleBgClick" style="width: 28%;" :class="multipleBgClickFlag?'item-content-active':'item-content'">
            <span>多背景</span>
            <span>￥{{((appInfo.multiple_background_price-appInfo.ele_price)/100).toFixed(2)}}</span>
          </div>
          <div @click="changeClothesClick" :style="{marginLeft:backgroundColor.length>1?'4%':'0%'}" style="width: 28%;"  :class="changeClothesClickFlag?'item-content-active':'item-content'">
            <span>个性换装</span>
            <span>￥{{((appInfo.change_clothe_price-appInfo.ele_price)/100).toFixed(2)}}</span>
          </div>
        </div>
        <div class="item">
          <div class="item-label">
            优惠服务
          </div>
          <div @click="extraClick(index)" :key="index" v-for="(item,index) in extraList" :style="{marginLeft:index>0?'4%':'0'}" style="width: 28%;" :class="item.flag?'item-content-active':'item-content'" >
            <span>{{item.extra_name}}</span>
            <span>￥{{(appInfo.extra_photo_price/100).toFixed(2)}}</span>
          </div>

        </div>
        <div class="tip">
          <div style="width: 90%;display: flex;align-items: center">
            <img style="width: 4%;" src="../assets/make/public/tip-icon.png">
            <span style="margin-left: 3%" >如果有问题请致电：18012485542</span>
          </div>
          <div style="width: 90%;padding-left:12%">
            <span>人工客服工作时间：周一至周五8：30-11：30 13：00-17：30（周末及节假日除外）</span>
          </div>
        </div>

      </div>
      <div class="footer">
        <div style="display: flex;justify-content: space-between;width: 20%">
          <div style="font-size: 12px;color: #35315C;line-height: 30px">总计:</div>
          <div style="font-size: 17px;color: #FF7BAC;line-height: 30px">￥{{(totalPrice/100).toFixed(2)}}</div>
        </div>
        <div @click="goPay" class="pay-btn">
          去支付
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import api from "../makeOnlineApi/api";
  import utils from "../makeOnlineApi/utils";
    export default {
        name: "OrderConfirmDialog",
        props:{
            backgroundColor:{
                required:true,
                default:[],
            },
            show:{
                default:false
            },
        },
        data(){
            return{
                appInfo:{},
                extraList:[],
                isPrint:false,
                multipleBgClickFlag:false,
                changeClothesClickFlag:false,

            }
        },
        computed:{

            totalPrice(){
                let ele=this.$store.state.appInfo.ele_price;
                let multipleBg = this.multipleBgClickFlag?this.$store.state.appInfo.multiple_background_price-this.$store.state.appInfo.ele_price:0;
                let changeClothes = this.changeClothesClickFlag?this.$store.state.appInfo.change_clothe_price-this.$store.state.appInfo.ele_price:0;
                let chooseExtra = this.extraList.filter((item=>{
                    return item.flag
                }));
                let extra = this.$store.state.appInfo.extra_photo_price*chooseExtra.length;
                let total_Price = ele+multipleBg+changeClothes+extra;
                return total_Price;
            }
        },
        watch:{

            "$store.state.sizeInfo":function (newProps) {


                if (newProps.spec_id===-4){
                    this.extraList=this.extraListUtil(newProps.extra_spec_info)
                    this.isPrint=false
                }else{
                    this.getNoCustomSizeInfo()

                }
            },
            "$store.state.clothesId":function (newProps) {

                this.changeClothesClickFlag=newProps==='-1'?false:true
            },
        },
        created() {
            if (this.$store.state.sizeInfo.spec_id===-4){
                this.extraList=this.extraListUtil(this.$store.state.sizeInfo.extra_spec_info)
                this.isPrint=false
            }else{
                this.getNoCustomSizeInfo()
            }



            this.appInfo = this.$store.state.appInfo
            console.log('this.$store.state.clothesId',this.$store.state.clothesId)
            this.changeClothesClickFlag=this.$store.state.clothesId==='-1'?false:true
        },
        methods:{
            getNoCustomSizeInfo(){
                this.$store.state.sizeInfo.spec_id&&api.getSizeInfo (this.$store.state.sizeInfo.spec_id).then(res=>{
                    this.extraList=this.extraListUtil(res.data.result.extra_spec_info)
                    this.isPrint = res.data.result.photo_params.is_print

              })
            },

            // 为了方便做选中功能 给list每一项 添加一个是否选中的flag
            extraListUtil(list){
                let extraList = list.map(item=>{
                    return {...item,flag:false}
                })
                return extraList
            },
            closeShow(){
                // close是在父组件on监听的方法
                // 第二个参数是需要传的值
                this.$emit('close', false)
            },

            multipleBgClick(){
                this.multipleBgClickFlag=!this.multipleBgClickFlag
            },

            changeClothesClick(){
                console.log(this.$store.state.clothesId,this.$store.state.clothesId==='-1')
                if (this.$store.state.clothesId==='-1'){
                  //
                    this.$message.error({
                        message:'您还未选择正装，请先选择您所需的正装模板！'

                    })
                }else {
                    this.changeClothesClickFlag=!this.changeClothesClickFlag
                }

            },

            extraClick(index){
                const item = {...this.extraList[index],flag:!this.extraList[index].flag}
                this.extraList.splice(index,1,item)

            },
            goPay(){

                let getExtraIdList=(id)=>{
                    return new Promise((resolve)=>{
                        const fair_level=this.$store.state.fairLevel
                        const clothesId=this.$store.state.clothesId
                        let option={
                            spec_id:id,
                            key:this.$store.state.originKey,
                            fair_level:fair_level,
                            list_clothes_id:this.changeClothesClickFlag?[clothesId]:['-1'],
                            need_resize:true,
                        }
                        api.getCertificatePhotoTaskId(option).then((res)=>{
                            let taskId=res.data.task_id
                            let getPhotoByTaskId=(taskId)=>{
                                api.getPhotoByTaskId(taskId).then(resPhoto=>{

                                    let params={
                                        spec_id:id,
                                        back_number:this.multipleBgClickFlag?-1:utils.getBackNumberByName(this.$store.state.bgNameSelected,this.$store.state.sizeInfo.spec_id===-4?utils.colorToLinearGradient(this.$store.state.sizeInfo.background_color):this.$store.state.sizeInfo.background_color),
                                        img_key:resPhoto.data.result[resPhoto.data.result.length-1].key
                                    }

                                    resolve(params)

                                }).catch(error=>{
                                    if (error.code!==482){
                                        //
                                    }else {
                                        setTimeout(()=>{
                                            getPhotoByTaskId(taskId)
                                        },500)

                                    }
                                })
                            }
                            getPhotoByTaskId(taskId)
                        })
                    })
                }
                let extraChoose=[]
                this.extraList.forEach(item=>{
                    if(item.flag){
                        extraChoose.push({...item})
                    }
                })
                if(extraChoose.length>0){

                    let list=[]
                    extraChoose.forEach(item=>{
                        list.push(getExtraIdList(item.extra_id))
                    })
                    const loading = this.$loading({
                        lock: true,
                        text: '优惠服务制作中',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    Promise.all(list).then((result) => {

                        loading.close()
                        this.getSerialNumberFn(result)
                    })
                }else{
                    //
                    this.getSerialNumberFn([])
                    console.log('没有优惠')
                }

            },

            getSerialNumberFn(extraPhotoKey){
                const loading = this.$loading({
                    lock: true,
                    text: '订单生成中',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                console.log(this.$store.state.currentPhoto,this.changeClothesClickFlag)
                let option = {
                    spec_id:this.$store.state.sizeInfo.spec_id,
                    img_key:this.changeClothesClickFlag?this.$store.state.currentPhoto[this.$store.state.currentPhoto.length-1].key:this.$store.state.currentPhoto[0].key,
                    original_key:this.$store.state.originKey,
                    custom_text:'',
                    extra_photo_key:[...extraPhotoKey],
                    custom_params:this.$store.state.sizeInfo.spec_id===-4?this.$store.state.sizeInfo:{},
                }
                api.getSerialNumber(option)
                    .then(res=>{
                        console.log(res.data.result.serial_number)
                        let options= {
                            // promotion_code:'2.99haha',
                            serial_number: res.data.result.serial_number,
                            is_fair:true,
                            back_number:this.multipleBgClickFlag?-1:utils.getBackNumberByName(this.$store.state.bgNameSelected,this.$store.state.sizeInfo.spec_id===-4?utils.colorToLinearGradient(this.$store.state.sizeInfo.background_color):this.$store.state.sizeInfo.background_color),
                            change_clothes:this.changeClothesClickFlag
                        }
                        api.getOrderId(options).then(res=>{
                            loading.close()
                            this.$emit('goPay',res.data)
                        }).catch(()=>{
                            loading.close()
                        })


                    })
                    .catch(()=>{
                        loading.close()
                    })

            },
        }
    }
</script>

<style scoped>
  .mask{
    background-color: rgba(0,0,0,0.4);

    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    z-index: 1000;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
  }
  .dialog{
    width: 40%;
    background-color:white ;
    display: flex;
    align-items: center;
    flex-direction: column;
    border-radius: 4px;

  }
  .title{
    width: 95%;padding-left: 5%;display: flex;justify-content: space-between;align-items: center;
    font-size: 14px;color: #35315C;border-bottom: 1px dashed rgba(53,42,92,0.4);
    font-weight: 600;
  }
  .content{
    padding: 0 8%;
    display: flex;
    flex-direction: column;
    width:85% ;
  }
  .item{
    width: 100%;
    margin-top: 20px;
    display: flex;
    align-items: center;
  }
  .item-label{
    font-size: 12px;
    color: #35315C;
    width: 20%;
    line-height: 40px;
    font-weight: 600;
  }
  .item-content{
    background-color: #F5F6FA;
    border-radius: 4px;
    height: 40px;
    display: flex;
    justify-content: space-between;
    line-height: 40px;
    padding: 0 5%;
    font-size: 13px;
    color: #35315C;
    cursor: pointer;
  }
  .item-content-active{
    background-color: rgba(75,0,164,0.05);
    border-radius: 4px;
    height: 38px;
    display: flex;
    justify-content: space-between;
    line-height: 40px;
    padding: 0 5%;
    font-size: 13px;
    color: #4B00A4;
    border: 1px solid #4B00A4;
    cursor: pointer;
  }
  .tip{
    background-color: #FFFBE6;
    border-radius: 4px;
    border: 1px solid #FFE58F;
    flex-direction: column;
    font-size: 12px;
    width: 100%;
    margin: 20px 0;
    display: flex;
    align-items: center;
    padding: 8px 0;
  }
  .footer{
    width: 92%;
    height: 80px;
    border-top: 1px solid #DEDEE4;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 4%;
  }
  .pay-btn{
    width: 25%;
    height: 36px;
    text-align: center;
    border-radius:18px;
    color: #FFFFFF;
    font-size: 14px;
    cursor: pointer;
    line-height: 36px;
    background-color: #4B00A4;
  }

</style>
